export default __webpack_public_path__ + "static/media/huawei_p40_pro_phone.e5ea33e1.jpg";